<script lang="ts" generics="Values">
  import { createEventDispatcher, onMount } from "svelte";
  import { createForm } from "./createForm";

  export let defaultValues: Values;
  export let resetOnSubmit = false;
  export let initalSubmit = false;
  export let form = createForm(defaultValues);

  const dispatch = createEventDispatcher<{ submit: Values; change: Values }>();

  form.subscribe((values) => {
    dispatch("change", values);
  });

  const submit = () => {
    dispatch("submit", { ...$form });
    if (resetOnSubmit) form.reset();
  };

  onMount(() => {
    if (initalSubmit) submit();
  });
</script>

<form {...$$restProps} on:submit|preventDefault={submit}>
  <slot {form} values={$form} />
</form>
